import React, { useContext, useEffect, useState } from 'react'
import { IProjectModel, IWorkSpaceModal, ProjectTypeEnum, ThemeTypes } from '../../models/SharedModel';
import Service from '../../services';
import { toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { RoutesEnum } from '../../models/RoutesModel';
import { ProjectStatus } from '../../models/ProjectModel';
import WorkSpaceForm from '../shared/WorkSpaceForm';
import { getFromSession } from '../../helpers/GenericHelpers';
import { ThemeContext } from '../../models/ThemeContext';

interface INewProjectModalProps {
  workSpaceModal: boolean;
  toggleWorkSpaceModal: () => void;
  apiSuccessCallback?: Function;
  getWorkSpaces?:Function;
}

const WorkSpaceModal = (props: INewProjectModalProps) => {

  const { workSpaceModal, toggleWorkSpaceModal, getWorkSpaces } = props;
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [workSpace, setWorkSpace] = useState<Partial<IWorkSpaceModal> | null>({}); // set project data for the modal
  const service = new Service();

  const cancelWorkSpace = (project?: Partial<IProjectModel>) => {
    setWorkSpace({})
    toggleWorkSpaceModal()
  }

  const createWorkSpace = (workSpace:IWorkSpaceModal) =>{
    const user_id = getFromSession('user_id');
    const data = {
      workspace_name:workSpace.workspace_name,
      workspace_owner:user_id,
      list_of_users:selectedOptions?.map((ele:any) => ele?.value)
    }
    service.create_workspace(data).then((response:any)=>{
      toast.success(response?.data)
      cancelWorkSpace();
      getWorkSpaces && getWorkSpaces();
    }).catch((error:any)=>{
      console.log(error)
    })
  }

  const { themeName } = useContext(ThemeContext);
  return (
    <Modal
      className={`project-modal map-workspace-modal ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
      isOpen={workSpaceModal}
      toggle={toggleWorkSpaceModal}
    >
      <ModalHeader toggle={toggleWorkSpaceModal}>{
        'Create New WorkSpace'
      }</ModalHeader>
      <ModalBody>
        <WorkSpaceForm
          workSpace={workSpace}
          cancelWorkSpace={cancelWorkSpace}
          setWorkSpace={setWorkSpace}
          submitWorkSpace={createWorkSpace}
          setSelectedOptions={setSelectedOptions}
          selectedOptions={selectedOptions}
        />
      </ModalBody>
    </Modal>
  )
}

export default WorkSpaceModal